import { __rest } from "tslib";
import * as React from 'react';
import { ClassNames } from '../../utils/classNames';
import { Icon, IconUtils } from '../icon';
/** Renders a spinner centred in the div that's being wrapped */
export const Spinner = React.forwardRef((_a, ref) => {
    var { children, className, icon, fillContainer, label } = _a, HTMLProps = __rest(_a, ["children", "className", "icon", "fillContainer", "label"]);
    return (React.createElement("div", Object.assign({ ref: ref, className: ClassNames.concat('arm-spinner', className) }, HTMLProps, { "data-fill-container": fillContainer }),
        React.createElement("div", { className: "arm-spinner-inner" }, children || (icon && React.createElement(Icon, { iconSet: icon.iconSet, icon: icon.icon, cypressTag: "spinner" }))),
        label && (React.createElement("div", { className: "arm-spinner-label" },
            React.createElement("span", null, label)))));
});
Spinner.defaultProps = {
    icon: IconUtils.getIconDefinition('Icomoon', 'spinner2'),
    fillContainer: true,
};
